import CommonNav from './CommonNav'
import React, { useRef, useEffect, useState } from 'react';
import { DataView } from 'primereact/dataview';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Endpoints } from "../constants/env/middletier";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useSearchParams } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';
import { useKeycloak } from "@react-keycloak/web";
import { Message } from 'primereact/message';
import { Fieldset } from 'primereact/fieldset';
import { ScrollPanel } from 'primereact/scrollpanel'
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from "react-router-dom";

export default function ViewMySubRequestFancy() {
    const [result, setResult] = useState([]);
    const [myJobs, setMyJobs] = useState([]);
    const [selectedJobs, setSelectedJobs] = useState([]);
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [jobAvailable, setJobAvailable] = useState(true);

    const substituteJobId = searchParams.get("substitute_job_id");
    const substituteId = searchParams.get("sub_id");

    const { keycloak, initialized } = useKeycloak();
    const userId = keycloak.tokenParsed.sub;
    const userFullName = keycloak.tokenParsed.name;
    console.log("User ID:", userId);
    console.log("User Name:", userFullName);

    const [products, setProducts] = useState([]);
    const [sortKey, setSortKey] = useState('');
    const [sortOrder, setSortOrder] = useState(0);
    const [sortField, setSortField] = useState('');
    const sortOptions = [
        { label: 'Date High to Low', value: '!price' },
        { label: 'Date Low to High', value: 'price' }
    ];
    const [showFullNotes, setShowFullNotes] = useState(false);
    const [showFullDescription, setShowFullDescription] = useState(false);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [showCancelCompleted, setShowCancelCompleted] = useState(false);

    const navigate = useNavigate();



//    useEffect(() => {
//        ProductService.getProductsSmall().then((data) => setProducts(data.slice(0, 5)));
//    }, []);

    const toggleNotes = () => {
        setShowFullNotes(!showFullNotes);
    };

    const toggleDescription = () => {
        setShowFullDescription(!showFullDescription);
    };

//    const getCustomers = (data) => {
//        return [...(data || [])].map((d) => {
//            d.date = new Date(d.date);
//
//            return d;
//        });
//    };


    const parseLocalDate = (dateStr) => {
        const [year, month, day] = dateStr.split("-").map(Number);
        return new Date(year, month - 1, day);
    };

    useEffect(() => {
    async function fetchMySubJob() {
        try {
            const res = await fetch(Endpoints["getmysubjobs"] + `${userId}`);
            const data = await res.json();

            const jobs = data.map(job => ({
                ...job,
                startDate: parseLocalDate(job.startDate),  // <-- real Date object
                endDate: parseLocalDate(job.endDate),  // <-- real Date object
            }));

            setMyJobs(jobs);
            console.log("Data");
            console.log(jobs);
            initFilters();
        } catch (err) {
            console.error("Failed to load my jobs", err);
        } finally {
            setLoading(false);
        }
    }
        fetchMySubJob();
    }, []);


    const onSortChange = (event) => {
        const value = event.value;

        if (value.indexOf('!') === 0) {
            setSortOrder(-1);
            setSortField(value.substring(1, value.length));
            setSortKey(value);
        } else {
            setSortOrder(1);
            setSortField(value);
            setSortKey(value);
        }
    };

//    const header = () => {
//        return <Dropdown options={sortOptions} value={sortKey} optionLabel="label" placeholder="Sort By Price" onChange={onSortChange} className="w-full sm:w-14rem" />;
//    };

    const notesBodyTemplate = (job) => {
        const isLong = job.notes?.length > 45;
        return (
            <ScrollPanel style={{ width: '300px', height: isLong ? '80px' : '20px' }}>
                {job.notes}
            </ScrollPanel>
        );
    };

    const descriptionBodyTemplate = (job) => {
        const isLong = job.notes?.length > 45;
        return (
            <ScrollPanel style={{ width: '300px', height: isLong ? '80px' : '20px' }}>
                {job.description}
            </ScrollPanel>
        );
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const startDateBodyTemplate = (rowData) => {
//        if (!rowData.startDate || rowData.startDate.length < 1) return null;
        return formatDate(new Date(rowData.startDate));
    };

    const endDateBodyTemplate = (rowData) => {
//        if (!rowData.endDate || rowData.startDate.length < 1) return null;
        return formatDate(new Date(rowData.endDate));
    };




    const editBodyTemplate2 = (job) => {
        return (
            <>
            something
            </>
        );
    };


    const submitCancelRequest = async (job) => {
        console.log("Canceling");
        console.log(job);

        const messageAndCreateJob = {
            "subs": null,
            "subJobRequested": {
                "teacherId": null,
                "teacherFullName": null,
                "startDate": null,
                "endDate": null,
                "description": null,
                "notes": null,
                "subjectId": null,
                "status": null
            }
        };



        try {
          const response = await fetch(Endpoints["cancelsubjob"] + `${job.id}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(messageAndCreateJob),
          });

          const result = await response.json();
          console.log("Success:", result);
        } catch (error) {
          console.error("Error sending messages:", error);
        } finally {
            setShowCancelCompleted(true);
        }
    };

    const handleCancelComplete = () => {
        if (!showCancelCompleted)
            return;

        console.log("navigate");
        console.log(navigate);
        navigate("/viewMyJobs");
//        setshowCancelCompleted(false);
        setShowCancelCompleted(false);
    };

    const showCancelCompletedfooterContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={handleCancelComplete} autoFocus />
        </div>
    );

    const editBodyTemplate = (job) => {
        return<Button label="Cancel" severity="danger" size="small" outlined onClick={() => submitCancelRequest(job)}/>;
    };

    const itemTemplate = (job, index) => {
        return (
            <>

                <div className="col-12" key={job.id}>
                    <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': index !== 0 })}>
                            <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                                <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                                    <div className="text-2xl font-bold text-900">Subing For: {job.teacherFullName}</div>
                                    <div className="flex align-items-center gap-3">
                                        <span className="flex align-items-center gap-2">
                                            <i className="pi pi-calendar"></i>
                                            <span className="font-semibold">Dates: {job.startDate} - {job.endDate}</span>
                                        </span>
                                        <span className="flex align-items-center gap-2">
                                            Notes:
                                            {!showFullNotes && (
                                                job.notes.length > 40 ? job.notes.substring(0, 40) + "..." : job.notes
                                            )}
                                            {showFullNotes && (
                                                <ScrollPanel style={{ width: '300px' }}>
                                                    {job.notes}
                                                </ScrollPanel>
                                            )}
                                            {job.description.length > 40 && <Button link label={showFullNotes ? "Less" : "More"} onClick={toggleNotes}/>}
                                        </span>
                                        <span className="flex align-items-center gap-2">
                                            Description:
                                            {!showFullDescription && (
                                                job.description.length > 40 ? job.description.substring(0, 40) + "..." : job.description
                                            )}
                                            {showFullDescription && (
                                                <ScrollPanel style={{ width: '300px'}}>
                                                    {job.description}
                                                </ScrollPanel>
                                            )}
                                            {job.description.length > 40 && <Button link label={showFullDescription ? "Less" : "More"} onClick={toggleDescription}/>}
                                        </span>
                                    </div>
                                </div>
                                <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                                    <span className="text-xl font-semibold">{job.startDate}</span>
                                    <Button icon="pi pi-shopping-cart" className="p-button-rounded" ></Button>
                                </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = myJobs.map((job, index) => {
            return itemTemplate(job, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };



    //========================================
    // FILTERING
    //========================================

    const clearFilter = () => {
//        initFilters();
        clearAllFilters();
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        console.log("e");
        console.log(e);
        let _filters = { ...filters };

        _filters['global'].value = value;
        console.log("value");
        console.log(value);
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            notes: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            startDate: { operator: FilterOperator.AND, constraints: [{ value: new Date(), matchMode: 'gte' }] },
            endDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
        });
        setGlobalFilterValue('');
    };

    const clearAllFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            notes: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            startDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
            endDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
        });
        setGlobalFilterValue('');
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="View Past Jobs" outlined onClick={clearFilter} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </IconField>
            </div>
        );
    };

    const filterClearTemplate = (options) => {
        return <Button type="button" icon="pi pi-times" onClick={options.filterClearCallback} severity="secondary"></Button>;
    };

    const filterApplyTemplate = (options) => {
        return <Button type="button" icon="pi pi-check" onClick={options.filterApplyCallback} severity="success"></Button>;
    };

    const filterFooterTemplate = () => {
        return <div className="px-3 pt-0 pb-3 text-center">Filter by Country</div>;
    };

    const dateFilterTemplate = (options) => {
        console.log("options")
        console.log(options)
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
    };

    const header = renderHeader();


    return (
    <>
        <CommonNav></CommonNav>
        <br />
        <br />
        <div className="card">

            {false && <DataView value={myJobs} listTemplate={listTemplate} header={header()} sortField={sortField} sortOrder={sortOrder} />}
        </div>


        <div className="card flex flex-column align-items-center gap-3 ">
            <Card title="Your Jobs: " className="md:w-35rem">
                <div className="card flex flex-column align-items-center gap-5 ">
                    <DataTable value={myJobs} showGridlines scrollable scrollHeight="500px" loading={loading} dataKey="id"
                    filters={filters} globalFilterFields={['startDate', 'endDate', 'notes', 'status']} header={header}
                    emptyMessage="No jobs found." onFilter={(e) => setFilters(e.filters)}>


                        <Column field="teacherFullName" header="Substitute For"></Column>
                        <Column field="startDate" filter filterField="startDate" header="Start Date" dataType="date" style={{ minWidth: '10rem' }} body={startDateBodyTemplate} filter filterElement={dateFilterTemplate}></Column>
                        <Column field="endDate" filter filterField="endDate" header="End Date" dataType="date" style={{ minWidth: '10rem' }} body={endDateBodyTemplate} filter filterElement={dateFilterTemplate}></Column>


                        <Column field="description" header="Description" body={descriptionBodyTemplate}></Column>
                        <Column field="notes" filter filterField="notes" header="Notes" body={notesBodyTemplate}></Column>
                        <Column field="status" filter filterField="status" header="Status"></Column>
                        <Column field="id" header="id"></Column>
                        <Column header="Edit" body={editBodyTemplate}></Column>
                    </DataTable>
                </ div>

                <Dialog header="Canceled" footer={showCancelCompletedfooterContent} visible={showCancelCompleted} style={{ width: '25vw' }} onHide={handleCancelComplete}>
                    <p className="m-0">
                        Job has been canceled
                    </p>
                </Dialog>
            </Card>
        </div>
    </ >
    );
}